// export const baseUrl = "http://192.168.1.219:5056"
// export const baseUrl = "https://a94b-94-140-9-250.ngrok.io"
// export const baseUrl = "https://localhost:7090"
// export const baseUrl = "http://192.168.1.2:5056"
// export const baseUrl = "https://api.infinityhomeservices.com";
export const baseUrl = import.meta.env?.VITE_BASE_URL ?? 'https://api-prod.infinityhomeservices.com'
